import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticleGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100" id="articles">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Latest <span className="text-primary-500">SEO Guides</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              Explore our comprehensive mulebuy spreadsheet guides, tutorials, and comparisons to master agent-based shopping.
            </p>
          </div>

          {/* Article Cards - First Row: 4 featured */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mb-8">
            {articles.slice(0, 4).map((article) => (
              <Link
                key={article.id}
                to={`/${article.id}`}
                className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col hover:-translate-y-1"
              >
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  {article.isNew && (
                    <span className="absolute top-3 left-3 px-3 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-full">
                      New
                    </span>
                  )}
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs font-semibold text-accent-600 bg-accent-50 px-2.5 py-1 rounded-full">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime}</span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mt-auto">
                    {article.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>

          {/* Second Row: 9 more articles */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {articles.slice(4, 13).map((article) => (
              <Link
                key={article.id}
                to={`/${article.id}`}
                className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col hover:-translate-y-1"
              >
                <div className="relative w-full h-44 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  {article.isNew && (
                    <span className="absolute top-3 left-3 px-3 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-full">
                      New
                    </span>
                  )}
                </div>
                <div className="p-4 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs font-semibold text-accent-600 bg-accent-50 px-2 py-1 rounded-full">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime}</span>
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mt-1">
                    {article.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}